window.ScoreCalculation = {
  //BEDTIME SCORING SECTION----------------------------------------------------------------------------------------------------
  calculateScore: function(type, value) {
    switch (type) {
      case 'regularUsage':
        return this.calculateRegularUsageScore(value);
      case 'bedtimeTarget':
        return this.calculateBedtimeTargetScore(value);
      case 'wakeUpVariance':
        return this.calculateWakeUpVarianceScore(value);
      case 'dayToDayConsistency':
        return this.calculateDayToDayConsistencyScore(value);
        case 'sleepDuration':
        return this.calculateSleepDurationScore(value);
      default:
        console.error('Unknown score type:', type);
        return 0;
    }
  },
  calculateBedtimeTargetScore: function(averageDistance) {
    if (averageDistance <= 15) return 20;
    if (averageDistance <= 30) return 15;
    if (averageDistance <= 45) return 10;
    if (averageDistance <= 60) return 5;
    return 0;
  },
  calculateWakeUpVarianceScore: function(wakeUpAnalysis) {
    if (!wakeUpAnalysis || typeof wakeUpAnalysis.standardDeviation !== 'string') {
      console.error('Invalid wake-up analysis data:', wakeUpAnalysis);
      return 0;
    }
    // Convert the standard deviation string to minutes
    const [hours, minutes] = wakeUpAnalysis.standardDeviation.split('h ');
    const totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
    if (totalMinutes <= 30) return 20;
    if (totalMinutes <= 45) return 15;
    if (totalMinutes <= 60) return 10;
    if (totalMinutes <= 75) return 5;
    if (totalMinutes <= 90) return 0;
    
    return 0;
  },
  calculateRegularUsageScore: function(usageMetrics) {
    const { daysBetweenFirstAndLastUse, numberOfEvents, daysSinceLastUse } = usageMetrics;
    
    // Calculate usage percentage
    const usagePercentage = (numberOfEvents / daysBetweenFirstAndLastUse) * 100;
    
    // Determine initial score based on usage percentage
    let score;
    if (usagePercentage > 85) score = 20;
    else if (usagePercentage > 75) score = 15;
    else if (usagePercentage > 65) score = 10;
    else if (usagePercentage > 55) score = 5;
    else if (usagePercentage > 50) score = 0
      ;
    else score = 0;
    
    // Subtract points for days since last use
    const penaltyDays = Math.max(0, daysSinceLastUse - 1);
    score = Math.max(0, score - penaltyDays);
    
    return {
      score,
      usagePercentage
    };
  },
  calculateDayToDayConsistencyScore: function(variance) {
    if (variance <= 15) return 20;
    if (variance <= 25) return 15;
    if (variance <= 35) return 10;
    if (variance <= 45) return 5;
    if (variance <= 55) return 0;
    return 0;
  },
  calculateSleepDurationScore: function(duration) {
    if (duration >= 7 && duration <= 9) return 20;
    if (duration >= 6 && duration < 7) return 15;
    if (duration > 9 && duration <= 10) return 10;
    if (duration >= 5 && duration < 6) return 5;
    if (duration > 10 && duration <= 11) return 5;
    return 0;
  },
  
  //Routine SCORING SECTION----------------------------------------------------------------------------------------------------
  calculateTotalTimeConsistencyScore: function(standardDeviation) {
      if (standardDeviation < 10) return 25;
      if (standardDeviation < 20) return 20;
      if (standardDeviation < 30) return 15;
      if (standardDeviation < 40) return 10;
      if (standardDeviation < 60) return 5;
      return 0;
    },
  calculateFrequencyAdherenceScore: function(adherencePercentage) {
        if (adherencePercentage > 90) return 25;
        if (adherencePercentage > 80) return 20;
        if (adherencePercentage > 70) return 15;
        if (adherencePercentage > 60) return 10;
        if (adherencePercentage > 50) return 5;
        return 0;
    },
  calculateStreakScore: function(currentStreak) {
        if (currentStreak > 30) return 25;
        if (currentStreak > 20) return 20;
        if (currentStreak > 10) return 15;
        if (currentStreak > 5) return 10;
        if (currentStreak > 1) return 5;
        return 0;
    },

  calculateStartTimeConsistencyScore: function(standardDeviation) {
        if (standardDeviation <= 15) return 25;
        if (standardDeviation <= 30) return 20;
        if (standardDeviation <= 45) return 15;
        if (standardDeviation <= 60) return 10;
        return 0;
    },

  
  //Marker SCORING SECTION----------------------------------------------------------------------------------------------------
  calculateMarkerStartTimeConsistencyScore: function(standardDeviation) {
    if (standardDeviation <= 15) return 35;
    if (standardDeviation <= 30) return 25;
    if (standardDeviation <= 45) return 15;
    if (standardDeviation <= 60) return 10;
    if (standardDeviation <= 75) return 5;
    return 0;
  },
  calculateMarkerStreakScore: function(currentStreak) {
    if (currentStreak > 30) return 35;
    if (currentStreak > 20) return 30;
    if (currentStreak > 15) return 25;
    if (currentStreak > 10) return 20;
    if (currentStreak > 5) return 10;
    if (currentStreak > 1) return 5;
    return 0;
  },
  calculateMarkerFrequencyAdherenceScore: function(adherencePercentage) {
    if (adherencePercentage > 90) return 30;
    if (adherencePercentage > 80) return 25;
    if (adherencePercentage > 70) return 20;
    if (adherencePercentage > 60) return 15;
    if (adherencePercentage > 50) return 5;
    return 0;
  },
};